import { CellContext } from '@tanstack/react-table';
import { ReactNode } from 'react';

import { BaseCell, BaseCellProps } from './BaseCell';
import * as styles from './StackedCell.css';

export interface StackedCellValue {
  primary: ReactNode;
  secondary?: ReactNode;
}

export interface StackedCellProps<TData = unknown>
  extends Omit<BaseCellProps, 'children'> {
  context?: CellContext<TData, StackedCellValue>;
  primary?: ReactNode;
  secondary?: ReactNode;
}

export function StackedCell<TData>({
  context,
  ...props
}: StackedCellProps<TData>) {
  const value = context?.getValue() ?? {
    primary: props.primary,
    secondary: props.secondary,
  };

  if (!value) return <BaseCell {...props} />;

  return (
    <BaseCell {...props} showPadding>
      <div className={styles.container}>
        <div className={styles.primary}>{value.primary}</div>
        {value.secondary && (
          <div className={styles.secondary}>{value.secondary}</div>
        )}
      </div>
    </BaseCell>
  );
}
